import { Routes } from '@angular/router';
import { LandingPageComponent } from '@app/modules/template-generator/landing-page';
import { TemplateGeneratorComponent } from './template-generator.component';
import { EmailEditorComponent } from '@app/modules/template-generator/email-editor';
import { ShareCampaignComponent } from '@app/modules/template-generator/share-campaign/share-campaign.component';
import { LaunchCampaignComponent } from '@app/modules/template-generator/launch-campaign/launch-campaign.component';
import { SelectTemplateComponent } from '@app/modules/template-generator/select-template/select-template.component';
import { AuthGuard } from '@app/_guards';
import { NonInfluencerGuard } from '@app/_guards/non-influencer.guard';
import { SocialShareEditorComponent } from '@app/modules/template-generator/social-share-editor';
import { pageChangesGuard } from '@app/_guards/page-changes.guard';
import { pendingSaveGuard } from '@app/_guards/pending-save.guard';

export const TEMPLATE_GENERATOR_ROUTES: Routes = [
  {
    path: 'projects/:projectId/campaigns/:campaignId',
    component: TemplateGeneratorComponent,
    children: [
      {
        path: 'select',
        pathMatch: 'full',
        component: SelectTemplateComponent
      },
      {
        path: 'share',
        pathMatch: 'full',
        component: ShareCampaignComponent,
        canDeactivate: [pendingSaveGuard]
      },
      {
        path: 'personalize/social-image',
        pathMatch: 'full',
        component: SocialShareEditorComponent
      },
      {
        path: 'personalize/social-video',
        pathMatch: 'full',
        component: SocialShareEditorComponent,
        data: {shareMedia: 'video'}
      },
      {
        path: 'landing-page',
        pathMatch: 'full',
        component: LandingPageComponent,
        canDeactivate: [pageChangesGuard]
      },
      {
        path: 'email',
        pathMatch: 'full',
        component: EmailEditorComponent
      },
      {
        path: 'launch',
        pathMatch: 'full',
        component: LaunchCampaignComponent
      }
    ],
    canActivate: [AuthGuard, NonInfluencerGuard]
  }
];
